export default __webpack_public_path__ + "static/media/nav.852a1c06.png";